import moment from 'moment';
import config from '../preorder/configs/config';

export const isCampaignOngoing = () => {
  if (config.BrandNameEN !== 'FreeZone') return false;

  const currentMoment = moment().utcOffset(8);
  const startMoment = moment().utcOffset(8).set({ y: 2023, M: 4, D: 11 }).startOf('d');
  const endMoment = moment().utcOffset(8).set({ y: 2023, M: 5, D: 27 }).endOf('d');

  return currentMoment.isBetween(startMoment, endMoment);
};

export default {};
